export default "__VITE_ASSET__B5exAVwr__"